// extracted by mini-css-extract-plugin
export default {"page":"Terms_page__k1gz1","inner":"Terms_inner__+4IDQ","title":"Terms_title__qlr55","updated":"Terms_updated__6X5I-","section":"Terms_section__uawRl"};